import { render, staticRenderFns } from "./AlfaCoverageDisplay.vue?vue&type=template&id=66948df1&scoped=true&"
import script from "./AlfaCoverageDisplay.vue?vue&type=script&lang=js&"
export * from "./AlfaCoverageDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AlfaCoverageDisplay.vue?vue&type=style&index=0&id=66948df1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66948df1",
  null
  
)

export default component.exports